import React from 'react';

import {
  LTInputBox,
  LTLoader,
  LTText,
  LTDivider
} from '@lambdatestincprivate/lt-components';

import Filters from './Filters';
import StatusFilterChips from './StatusFilterChips';
import styles from './styles.module.css';

const SidebarTestList = ({
  searchText,
  onSearchChange,
  statusCounts,
  selectedStatuses,
  onStatusToggle,
  isLoading,
  isListLoading,
  children,
  showFilterButton,
  filters,
  filterOptions,
  onApplyFilter,
  filterTitle,
  filterData,
  filterDataLoading,
  onFilterOpen,
  onFilterSearch,
  emptyMessage,
  headerStyle,
}) => {
  const hasStatusCounts = statusCounts && Object.keys(statusCounts).length > 0;

  return (
    <div role="listbox" aria-label="Test list" className={styles.container}>
      {/* Header section with bottom border */}
      <div className={styles.headerSection} style={headerStyle}>
        <LTText
          variant={LTText.TextVariant.BODY_MEDIUM}
          color="fg.default"
          style={{ fontWeight: 600, fontSize: 14, lineHeight: '20px' }}
        >
          Tests
        </LTText>

        {/* Search + filter row */}
        <div className={styles.searchRow}>
          <LTInputBox
            autoCompleteType="off"
            value={searchText || ''}
            onChange={(value) => onSearchChange?.(value)}
            placeholder="Search test"
            trailingAction={() => onSearchChange?.('')}
            size={LTInputBox.Size.MEDIUM}
            aria-label="Search tests"
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
          />
          {showFilterButton && (
            <Filters
              filters={filters}
              filterOptions={filterOptions}
              onApplyFilter={onApplyFilter}
              title={filterTitle}
              filterData={filterData}
              filterDataLoading={filterDataLoading}
              onFilterOpen={onFilterOpen}
              onFilterSearch={onFilterSearch}
            />
          )}
        </div>

        {/* Status filter chips */}
        {hasStatusCounts && (
          <div className={styles.filterChipContainer}>
            <div
              role="group"
              aria-label="Status filters"
              className={styles.chipRow}
            >
              <StatusFilterChips
                statusCounts={statusCounts}
                selectedStatuses={selectedStatuses}
                onStatusToggle={onStatusToggle}
              />
            </div>
          </div>
        )}
      </div>
      <div className="mt-[8px] w-full">
        <LTDivider />
      </div>

      {/* List area */}
      {isLoading ? (
        <div className={styles.loaderContainer}>
          <LTLoader
            heading="Loading Tests"
            size={LTLoader.SpinnerSizes.MEDIUM}
          />
        </div>
      ) : (
        <div className={styles.listWrapper}>
          {isListLoading ? (
            <div className={styles.loaderContainer}>
              <LTLoader
                heading="Loading Tests"
                size={LTLoader.SpinnerSizes.MEDIUM}
              />
            </div>
          ) : (
            children || (
              <div className={styles.emptyState}>
                <LTText
                  variant={LTText.TextVariant.BODY_REGULAR}
                  color="fg.subtle"
                >
                  {emptyMessage || 'No tests found'}
                </LTText>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default SidebarTestList;
